import { useMemo } from "react";

/**
 * Хак, позволяющий устанавливать минимальную ширину тега td.
 * В tableColumns у целевых столбцов надо убрать ширину и добавить colSpan: "2".
 * В настройки таблицы добавить список целевых столбцов, например:
 * displayOptions: { columnsWithMinWidth: [{ name: "name", minWidth: "350px" }] }
 */
export const ColGroup = ({ columns, columnsWithMinWidth }) => {
	const clmByName = useMemo(
		() =>
			columnsWithMinWidth.reduce((acc, clm) => {
				return {
					...acc,
					[clm.name]: clm,
				};
			}, {}),
		[columnsWithMinWidth]
	);

	const cols = [];

	columns.forEach(({ name }, idx) => {
		if (name in clmByName) {
			cols.push(<col key={`${name}-withMinWidth-${idx}`} style={{ width: clmByName[name].minWidth }} />);
		}
		cols.push(<col key={`${name}-${idx}`} />);
	});

	return <colgroup>{cols}</colgroup>;
};
